import { getSignedAttachmentUrl } from './openSignedAttachment'

export async function downloadRemoteFile(
  url: string,
  filename: string
): Promise<void> {
  if (!url) return

  const targetUrl = await getSignedAttachmentUrl(url, true, filename)
  if (!targetUrl) return

  try {
    const res = await fetch(targetUrl, { mode: 'cors', credentials: 'omit' })
    if (!res.ok) throw new Error(String(res.status))
    const blob = await res.blob()
    const objectUrl = URL.createObjectURL(blob)
    try {
      const a = document.createElement('a')
      a.href = objectUrl
      a.download = filename || 'download'
      a.rel = 'noopener'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } finally {
      URL.revokeObjectURL(objectUrl)
    }
  } catch {
    const a = document.createElement('a')
    a.href = targetUrl
    a.download = filename || 'download'
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}
